// ═══ DOCUMENTE TAB ═══════════════════════════════════════════════════════════
// Rând document: click pe nume deschide fișierul; long-press 800ms → meniu redenumire/mutare/ștergere
import React, { useState } from "react";
import { t } from './i18n';
import { fmConfirm } from './dialog';
import { fmtD, confirmDelete } from './helpers';
import { CaregiverBadge, IconTrash } from './ui';

// Tipuri de fișiere acceptate la încărcare
const ACCEPTED = ".pdf,.jpg,.jpeg,.png,.doc,.docx,.xlsx,.csv,.txt,.heic,.tiff,.zip";

export function RenameDocForm({doc, onSave}) {
  const [name, setName] = useState(doc.name||"");
  return (
    <div>
      <div style={{marginBottom:16}}><div className="lbl">{t("Nume document")}</div>
        <input value={name} onChange={e=>setName(e.target.value)} autoFocus onKeyDown={e=>e.key==="Enter"&&name.trim()&&onSave(name.trim())}/>
      </div>
      <button className="bp" style={{width:"100%"}} disabled={!name.trim()} onClick={()=>name.trim()&&onSave(name.trim())}>{t("Salvează")}</button>
    </div>
  );
}
export function MoveDocForm({doc, onSave}) {
  const cats = ["Analize","Imagistică","Rețetă","Altele"];
  return (
    <div>
      <div className="lbl" style={{marginBottom:10}}>{t("Alege categoria")}</div>
      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        {cats.map(c=>(
          <button key={c} onClick={()=>onSave(c)}
            style={{padding:"11px 14px",borderRadius:8,textAlign:"left",fontFamily:"inherit",fontSize:14,cursor:"pointer",
              background:doc.category===c?"var(--blue-bg)":"var(--bg)",
              border:`1px solid ${doc.category===c?"#7c3aed":"var(--border-2)"}`,
              color:doc.category===c?"var(--blue-2)":"var(--text)"}}>
            {t(c)}{doc.category===c?"  ✓ "+t("(actual)"):""}
          </button>
        ))}
      </div>
    </div>
  );
}
export function DocRow({doc, onOpen, onExtract, onClearExtraction, onRename, onMove, onDelete, family, readOnly=false}) {
  const [menu, setMenu] = React.useState(false);
  const pressRef = React.useRef(null);
  const movedRef = React.useRef(false);

  function startPress(){ if(readOnly)return; movedRef.current=false; pressRef.current=setTimeout(()=>{ if(!movedRef.current) setMenu(true); }, 800); }
  function cancelPress(){ clearTimeout(pressRef.current); }

  return (
    <div style={{borderBottom:"1px solid var(--border)"}}>
      <div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 0"}}
        onTouchStart={startPress} onTouchEnd={cancelPress} onTouchMove={()=>{movedRef.current=true;cancelPress();}}
        onMouseDown={startPress} onMouseUp={cancelPress} onMouseLeave={cancelPress}>
        <div style={{width:36,height:36,borderRadius:8,background:"var(--border)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0,overflow:"hidden",cursor:"pointer"}}
          onClick={onOpen}>
          {doc.previewUrl?<img src={doc.previewUrl} style={{width:"100%",height:"100%",objectFit:"cover",borderRadius:8}} alt=""/>:doc.isPdf?"📄":"📋"}
        </div>
        <div style={{flex:1,minWidth:0,cursor:"pointer"}} onClick={onOpen}>
          <div style={{fontWeight:600,fontSize:13,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",color:"var(--blue)"}}>{doc.name}</div>
          <div style={{fontSize:11,color:"var(--text-3)"}}>
            {fmtD(doc.date)} · {doc.size}
            {doc.extracting&&<span style={{color:"var(--purple)",marginLeft:8}}>{t("⏳ Procesez...")}</span>}
            {doc.aiExtracted&&<span style={{color:"var(--green)",marginLeft:8,display:"inline-flex",alignItems:"center",gap:6}}>
              ✓ {t("Extras")}
              {!readOnly&&<button title={t("Șterge extragerea")} onClick={(e)=>{e.stopPropagation();fmConfirm(t("Ștergi toate valorile extrase din acest document?"),{danger:true,okText:"Șterge"}).then(ok=>{if(ok)onClearExtraction&&onClearExtraction(doc.id);});}}
                style={{background:"none",border:"none",color:"var(--red)",cursor:"pointer",padding:"1px 3px",fontSize:10,lineHeight:1}}>{t("✕ Anulează")}</button>}
            </span>}
          </div>
        </div>
        {!readOnly&&(doc.type==="analize"||doc.type==="altele"||doc.type==="imagistica")&&!doc.aiExtracted&&!doc.extracting&&(
          <button className="bai" style={{fontSize:11,padding:"4px 10px"}} onClick={onExtract}>{t("✦ AI")}</button>
        )}
        <CaregiverBadge addedBy={doc.addedBy} addedByName={doc.addedByName} addedByEmail={doc.addedByEmail} family={family} size={16}/>
        {!readOnly&&<button className="bg" style={{fontSize:14,padding:"4px 10px"}} onClick={()=>setMenu(m=>!m)} title={t("Opțiuni")}>⋯</button>}
      </div>
      {!readOnly&&menu&&(
        <div style={{display:"flex",gap:6,flexWrap:"wrap",padding:"0 0 10px 46px"}}>
          <button className="bg" style={{fontSize:11,padding:"5px 10px"}} onClick={()=>{setMenu(false);onRename();}}>{t("✎ Redenumește")}</button>
          <button className="bg" style={{fontSize:11,padding:"5px 10px"}} onClick={()=>{setMenu(false);onMove();}}>{t("→ Mută")}</button>
          <button className="bg" style={{fontSize:11,padding:"5px 10px",borderColor:"var(--red-bg)",color:"var(--red)"}} onClick={()=>{setMenu(false);onDelete();}}><IconTrash size={12}/>{t(" Șterge")}</button>
        </div>
      )}
    </div>
  );
}

export function DocumenteTab({docs,deleteDoc,updateDoc,fileRef,fileCatRef,handleUpload,imagingDocs,setModal,onExtract,onClearExtraction,family,savedDocOrder,onSaveDocOrder,readOnly=false}) {
  const [filter,setFilter] = useState("Toate");
  const [docOrder,setDocOrder] = React.useState(savedDocOrder||{});
  const [dragId,setDragId] = React.useState(null);
  const [dragOver,setDragOver] = React.useState(null);

  // Ordine per categorie: docOrder[cat] = [id1, id2, ...]
  function getSorted(catDocs, cat) {
    const order = docOrder[cat]||[];
    if(!order.length) return catDocs;
    const mapped = [...catDocs].sort((a,b)=>{
      const ia = order.indexOf(a.id); const ib = order.indexOf(b.id);
      if(ia===-1&&ib===-1) return 0;
      if(ia===-1) return 1;
      if(ib===-1) return -1;
      return ia-ib;
    });
    return mapped;
  }
  function saveOrder(cat, sortedDocs) {
    const newOrder = {...docOrder, [cat]: sortedDocs.map(d=>d.id)};
    setDocOrder(newOrder);
    if(onSaveDocOrder) onSaveDocOrder(newOrder);
  }
  function handleDrop(cat, targetId, catDocs) {
    if(!dragId||dragId===targetId) return;
    const sorted = getSorted(catDocs, cat);
    const from = sorted.findIndex(d=>d.id===dragId);
    const to = sorted.findIndex(d=>d.id===targetId);
    if(from===-1||to===-1) return;
    const next = [...sorted];
    next.splice(to,0,next.splice(from,1)[0]);
    saveOrder(cat, next);
    setDragId(null); setDragOver(null);
  }

  const filtered = filter==="Toate"?docs:docs.filter(d=>d.category===filter);
  const imgList = imagingDocs.sort((a,b)=>b.date.localeCompare(a.date));
  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:8}}>
        <div/>
        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
          {[["Analize","analize"],["Imagistică","imagistica"],["Rețetă","reteta"],["Altele","altele"]].map(([l,c])=>(
            <span key={c} style={{position:"relative",display:"inline-block"}}>
              <span className="bg" style={{fontSize:11,padding:"5px 10px",display:"inline-block",pointerEvents:"none"}}>↑ {t(l)}</span>
              <input type="file" multiple accept={ACCEPTED}
                style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",opacity:0,cursor:"pointer"}}
                onChange={(e)=>{fileCatRef.current=c;handleUpload(e);}}
                onClick={(e)=>{
                  // Pe Android (PWA), onChange nu se declanșează după selecția din galerie.
                  // Verificăm periodic dacă a apărut un fișier în input.
                  fileCatRef.current=c;
                  const inp=e.target;
                  let tries=0;
                  const timer=setInterval(()=>{
                    tries++;
                    if(inp.files&&inp.files.length>0){
                      clearInterval(timer);
                      handleUpload({target:inp});
                    }
                    if(tries>120) clearInterval(timer); // oprește după ~60s
                  },500);
                }}/>
            </span>
          ))}
        </div>
      </div>
      {imgList.length>=2&&(
        <button className="bg" style={{width:"100%",marginBottom:12,padding:"10px",fontSize:13,color:"var(--purple)",borderColor:"#2d1060",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}
          onClick={()=>setModal({type:"compareImaging",data:{imgList}})}>
          ⚖ {t("Compară studii imagistice")} ({imgList.length} {t("extrase")})
        </button>
      )}
      <div style={{display:"flex",gap:6,marginBottom:12,flexWrap:"wrap"}}>
        {["Toate","Analize","Imagistică","Rețetă","Altele"].map(c=>(
          <button key={c} onClick={()=>setFilter(c)} style={{background:filter===c?"#7c3aed":"var(--surface)",border:`1px solid ${filter===c?"#7c3aed":"var(--border-2)"}`,color:filter===c?"#fff":"var(--btn-ghost)",borderRadius:20,padding:"4px 12px",cursor:"pointer",fontSize:12,fontFamily:"inherit",transition:"all .2s"}}>{t(c)}</button>
        ))}
      </div>
      {filtered.length===0&&(
        <div className="card" style={{textAlign:"center",color:"var(--text-4)",padding:"48px 0"}}>
          <div style={{fontSize:40,marginBottom:8}}>📄</div>
          {docs.length===0?t("Niciun document încărcat."):t("Niciun document în această categorie.")}
        </div>
      )}
      {["Analize","Imagistică","Rețetă","Altele"].map(cat=>{
        const catDocs=filtered.filter(d=>d.category===cat);
        if(!catDocs.length) return null;
        return (
          <div key={cat}>
            <div className="sec">{t(cat)}</div>
            <div className="card" style={{padding:"4px 14px"}}>
              {getSorted(catDocs,cat).map(doc=>(
                <div key={doc.id}
                  draggable={!readOnly}
                  onDragStart={()=>!readOnly&&setDragId(doc.id)}
                  onDragEnd={()=>{ setDragId(null); setDragOver(null); }}
                  onDragOver={e=>{ if(readOnly)return; e.preventDefault(); setDragOver(doc.id); }}
                  onDrop={()=>!readOnly&&handleDrop(cat, doc.id, catDocs)}
                  style={{
                    opacity: dragId===doc.id ? 0.4 : 1,
                    borderTop: dragOver===doc.id&&dragId!==doc.id ? "2px solid var(--blue)" : "2px solid transparent",
                    transition:"border-color .1s"
                  }}>
                  <DocRow doc={doc} family={family} readOnly={readOnly}
                    onOpen={()=>{ const u=doc.fileUrl||doc.previewUrl; if(u) window.open(u,"_blank"); }}
                    onExtract={()=>onExtract(doc)}
                    onClearExtraction={onClearExtraction}
                    onRename={()=>setModal({type:"renameDoc",data:doc})}
                    onMove={()=>setModal({type:"moveDoc",data:doc})}
                    onDelete={()=>confirmDelete(undefined,()=>deleteDoc(doc.id))}
                  />
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
